<template>
  <ten-input
    ref="inputElm"
    :class="className"
    :value="value"
    :placeholder="_placeholder"
    v-bind="$attrs"
    v-on="listeners"
    @keydown="onKeyDown"
  >
    <template v-slot:inputPrefixRaw>
      <template v-if="collapseTags && tags.length">
        <ten-tag
          :closable="getTagClosable(tags[0])"
          @close="onTagDelete(tags[0])"
        >
          {{ getTagText(tags[0]) }}
        </ten-tag>
        <ten-tag v-if="tags.length > 1">
          + {{ tags.length - 1 }}
        </ten-tag>
      </template>

      <ten-tag
        v-else
        v-for="(tag, index) in tags"
        :key="index"
        :closable="getTagClosable(tag)"
        @close="onTagDelete(tag)"
      >
        {{ getTagText(tag) }}
      </ten-tag>
    </template>

    <template v-slot:inputSuffix>
      <span
        ref="inputMirrorElm"
        class="ten-input-tag__input-mirror"
      >{{ value }}</span>
    </template>

    <template
      v-for="name in inputSlotName"
      v-slot:[name]
    >
      <slot :name="name" />
    </template>
  </ten-input>
</template>

<script>
import Input from './input';
import Tag from '../tag';

const name = 'ten-input-tag';

export default {
  name,
  components: {
    TenInput: Input,
    TenTag: Tag,
  },
  inheritAttrs: false,
  props: {
    tags: { type: Array, default: () => [] },
    placeholder: String,
    getTagKey: { type: Function, default: tag => tag },
    getTagText: { type: Function, default: tag => tag },
    getTagClosable: { type: Function, default: () => true },
    value: { type: [Number, String], default: '' },
    collapseTags: Boolean,
  },
  computed: {
    className() {
      return [
        'ten-input-tag',
        {
          'ten-input-tag--empty': this.isEmpty,
        },
      ];
    },
    isEmpty() {
      return !this.tags.length && !this.value;
    },
    listeners() {
      const {
        'tag-delete': tagDelete,
        keydown,

        ...othersEvent
      } = this.$listeners;

      return { ...othersEvent };
    },
    hasSuffixIcon() {
      return this.$scopedSlots.suffixIcon || this.$attrs.suffixIcon;
    },
    _placeholder() {
      return this.tags.length ? '' : this.placeholder;
    },
    inputSlotName() {
      return Object.keys(this.$scopedSlots);
    },
  },
  updated() {
    const padding = this.hasSuffixIcon ? 40 : 16;

    const { inputElm, inputMirrorElm } = this.$refs;

    if (inputElm && inputElm.$refs.refInputElem && inputMirrorElm) {
      if (this.$attrs.readonly && !this.value) {
        inputElm.$refs.refInputElem.style.width = '';
      } else if (this.tags.length && !this.value) {
        inputElm.$refs.refInputElem.style.width = `calc(0.75em + ${padding}px)`;
      } else if (!this.tags.length && !this.value) {
        inputElm.$refs.refInputElem.style.width = '100%';
      } else {
        inputElm.$refs.refInputElem.style.width = `${Math.ceil(inputMirrorElm.getBoundingClientRect().width) + 10 + padding}px`;
      }
    }
  },
  methods: {
    onKeyDown(e) {
      const { disabled } = this.$attrs;
      if (disabled) return;
      this.$emit('keydown', e);
      if (!(this.tags.length > 0 && this.getTagClosable(this.tags[this.tags.length - 1]))) return;
      if (e.keyCode === 8 && this.value === '' && this.tags.length > 0) {
        this.onTagDelete(this.tags[this.tags.length - 1]);
      }
    },
    onTagDelete(tagToDelete) {
      const tagsAfterDelete = this.tags.filter(tag => this.getTagKey(tag) !== this.getTagKey(tagToDelete));
      this.$emit('tag-delete', tagToDelete, tagsAfterDelete);
    },
  },
};
</script>
